import { AuthState } from '@okta/okta-auth-js';

import { CashAdjustment } from '../../services/backend/CashAdjustment';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCashAdjustment: () => CashAdjustment<AuthState> = () => {
  return useBaseApiClient(CashAdjustment);
};
